import type { HTTPClient, APIOptions } from '../core/http-client.js';
import { API_ENDPOINTS } from '../core/constants.js';
import type { AttachmentUploadRequest, AttachmentUploadResponse } from '../types/attachments.js';

export class AttachmentsAPI {
  constructor(private httpClient: HTTPClient) {}

  async upload(
    request: AttachmentUploadRequest,
    options?: APIOptions,
  ): Promise<AttachmentUploadResponse> {
    // Format according to official API - no message wrapper needed
    const body = {
      message: {
        attachment: {
          type: request.type,
          payload: {
            url: request.url,
            is_reusable: request.is_reusable ?? true,
          },
        },
      },
    };

    return this.httpClient.request<AttachmentUploadResponse>({
      method: 'POST',
      path: API_ENDPOINTS.MESSAGE_ATTACHMENTS,
      body,
      accessToken: options?.accessToken,
    });
  }
}
